
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 10.91c0-.503.448-.91 1-.91s1 .407 1 .91v18.18c0 .503-.448.91-1 .91s-1-.407-1-.91V10.91zm-8 17.426v3.188C22 33.932 20.62 36 18.679 36h-3.362C13.38 36 12 33.931 12 31.524v-5.64l-4.01-.983C6.82 24.614 6 23.583 6 22.4v-6.565c0-1.241.902-2.306 2.144-2.534l28.741-5.285c.58-.106 1.115.33 1.115.907v22.153c0 .601-.575 1.042-1.17.896L22 28.336zm-2-.49l-6-1.471v5.149c0 1.433.696 2.476 1.317 2.476h3.362C19.304 34 20 32.958 20 31.524v-3.678zm-6.141-3.359L36 30V10L8.603 15.117A.737.737 0 008 15.84v6.611c0 .34.23.634.56.716l3.922.976a1 1 0 011.376.343z"}})])
          )
        }
      }
    